export const LogoMark = ({ className = "h-8 w-8 sm:h-10 sm:w-10" }) => (
  <img
    src="/logo-mark.png"
    alt="Logotipo SG Turismos"
    className={`${className} object-contain`}
    draggable={false}
  />
);

export default function Logo({ dark = false }) {
  return (
    <span className="flex items-center gap-2.5 sm:gap-3">
      <LogoMark />
      <span className="flex flex-col leading-none">
        <span
          className={`whitespace-nowrap font-serif text-lg tracking-wide sm:text-xl ${dark ? "text-paper" : "text-navy"}`}
        >
          SG Turismos
        </span>
        <span
          className={`mt-1 hidden text-[0.6rem] uppercase tracking-[0.35em] sm:block ${dark ? "text-air" : "text-dusk"}`}
        >
          Cruzeiros
        </span>
      </span>
    </span>
  );
}
